import Styled, { css } from 'styled-components';

import { media } from '../../../lib/StyledComponents';

export const ProgressTrackerHeaderContainer = Styled.div`
  justify-content: space-between;
  border-top: 1px solid ${props => props.theme.colorSlate5};
  height: 100%;
  padding: ${({ theme: { progressTracker} }) => progressTracker.headerContainerPadding};
  display: flex;
  align-items: center;

  ${({ theme }) =>
   css`
    ${media[theme.header.subNavBreakPoint]`
      flex: 0 1 60%;
      border: none;
    `}
  `}
`;
